import {
  CopyFilled,
  ContainerOutlined,
  MenuFoldOutlined,
  PieChartOutlined,
  DesktopOutlined,
  MailOutlined,
  MenuUnfoldOutlined,
  SnippetsFilled,
  AndroidFilled,
  AppleFilled,
  WindowsFilled,
  YoutubeFilled,
  FacebookFilled,
  InstagramFilled,
  BellFilled,
  CalendarFilled,
  BugFilled,
  FileExcelFilled,
  FileImageFilled,
  FilePdfFilled,
  FileWordFilled,
  GoldFilled
} from '@ant-design/icons';
import { Button, Menu,message,Modal,Form,Input,Tooltip } from 'antd';
import { useState, useEffect } from 'react';
import { NavLink, useNavigate,useLocation } from "react-router-dom";
import dummyData from "../utils/dummyData";
import axios from 'axios';
import "../styles/sidebar.css";
import Logo from '../assets/CGnetLOGO.png';
const { SubMenu } = Menu;

const Sidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [role,setRole] = useState();
  const [uuid,setUuid] = useState("");
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  useEffect(()=>{
    const userString = sessionStorage.getItem("user");
    const value = JSON.parse(userString);
    setRole(value ? value.role : '');
    setUuid(value ? value.uuid : "")
  })

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/menu`)
      .then(response => {
        // Handle success
          let k = 100
        const modifiedResponse = response.data.map(item => ({
          ...item,
          key: item.name,
          label: item.name // Set the 'key' property with the 'id' value
        }));

        modifiedResponse.push(...dummyData);
        // console.log('mmmmmm',modifiedResponse)
        setData(modifiedResponse);
      })
      .catch(error => {
        // Handle error
        console.error(error);
      });

  }, []);



  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
    document.getElementById('rightContainer').classList.toggle('viewAuto');
  };



  const getIconComponent = (icon) => {
    switch (icon) {
      case 'PieChartOutlined':
        return <PieChartOutlined />;
      case 'DesktopOutlined':
        return <DesktopOutlined />;
      case 'MailOutlined':
        return <MailOutlined />;
      case 'ContainerOutlined':
        return <ContainerOutlined />;
      case 'CopyFilled':
        return <CopyFilled />;
      case 'SnippetsFilled':
        return <SnippetsFilled />
      case 'AndroidFilled':
        return <AndroidFilled />
      case 'AppleFilled':
        return <AppleFilled />
      case 'windows':
        return <WindowsFilled />
      case 'YoutubeFilled':
        return <YoutubeFilled />
      case 'FacebookFilled':
        return <FacebookFilled />
      case 'InstagramFilled':
        return <InstagramFilled />
      case 'BellFilled':
        return <BellFilled />
      case 'CalendarFilled':
        return <CalendarFilled />
      case 'BugFilled':
        return <BugFilled />
      case 'FileExcelFilled':
        return <FileExcelFilled />
      case 'FileImageFilled':
        return <FileImageFilled />
      case 'FilePdfFilled':
        return <FilePdfFilled />
      case 'FileWordFilled':
        return <FileWordFilled />
      case 'GoldFilled':
        return <GoldFilled />
      default:
        return <ContainerOutlined />;
    }
  };



  const renderMenuItems = (items) => {
    return items.map((item) => {
      if (item.type === 'item' && !item.uuid) {
        const IconComponent = getIconComponent(item.icon);
        return (

          <Menu.Item key={item.key} icon={IconComponent}>
            <NavLink to={item.link}>{item.label}</NavLink>
          </Menu.Item>
        );
      } else if (item.type === 'submenu') {
        const IconComponent = getIconComponent(item.icon);
        return (
          <SubMenu key={item.key} icon={IconComponent} title={item.label}>
            {renderMenuItems(item.children)}
          </SubMenu>
        );
      }
    });
  };



  const renderApiMenu = (items) => {
    return items.map((item) => {
      if (item.type === 'item' && item.uuid) {
        const IconComponent = getIconComponent(item.icon);

        return (
          <div key={item.key} className='apiMenu'>

            <div className='apiMenu'>
            <Tooltip title={item.label}>
            <NavLink to={`/product_menu/?mEnc=${item.uuid}`} >{IconComponent} {item.label}</NavLink>
            </Tooltip>
            </div>
          </div>
        );
      } else {

      }
    });
  };



const logoutHandler = () =>{
  axios.delete(`${process.env.REACT_APP_API_URL}/logout`)
        .then(response => {
         
          sessionStorage.removeItem("user");
          message.success('logout successful!');
          setTimeout(() => {
            // Redirect the user to the dashboard
            navigate("/login");
          }, 1000);
        })
        .catch(error => {
          console.error(error);
          // message.error('Error logging out!');
          sessionStorage.removeItem("user");
          navigate("/login");
        });
}


const forgotHandler = () =>{
  setOpen(true)
}
const handleOk = () => {
  setTimeout(() => {
    setOpen(false);
  }, 1000);
};
const handleCancel = () => {
  form.resetFields();
  setOpen(false);
};

const onFinish = values => {
  // console.log('usersForm value',values)

   // Update existing menu item
    axios
      .patch(`${process.env.REACT_APP_API_URL}/users/${uuid}`, values)
      .then(response => {
        // console.log(response.data);
      
      })
      .catch(error => {
        console.error(error);
      });


  handleCancel();
};

const onFinishFailed = errorInfo => {
  console.log('Failed:', errorInfo);
};

let productParam = searchParams.get('prMod');
  return (
    <div style={{ width: 218 }} className={collapsed ? 'collapsed' : ''}>
      <div className='d-none'>
   
      </div>
      <div className="menuWrapper" id={role == 'admin'? 'ena':'enu'}>
       <Tooltip title="toggle sidebar">
       <Button
          type="primary"
          onClick={toggleCollapsed}
          style={{
            marginBottom: 16,
          }}
        >
          {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        </Button>
       </Tooltip>


        <Menu
          defaultSelectedKeys={['1']}
          defaultOpenKeys={['sub1']}
          mode="inline"
          theme="light"
          inlineCollapsed={collapsed}
        >
          <img src={Logo} alt="img failed" srcSet="" />
          {renderMenuItems(data)}
          
          {renderApiMenu(data)}
         {role != 'admin' ?  <Button type='dashed' id='logout' className='forgot' onClick={forgotHandler}>Change Password?</Button>:null}
          <Button type='dashed' id='logout' onClick={logoutHandler}>Logout</Button>
        </Menu>
        
      </div>
      <Modal
      open={open}
      title="Add User"
      onOk={handleOk}
      onCancel={handleCancel}
      footer={[
        <Button key="back" onClick={handleCancel}>
          Return
        </Button>,
        <Button key="submit" type="primary" htmlType="submit" form="userForm">
          Submit
        </Button>
      ]}
    >
      <Form
        name="basic"
        labelCol={{
          span: 8,
        }}
        wrapperCol={{
          span: 16,
        }}
        style={{
          maxWidth: 600,
        }}
        
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        id="userForm" // Add an ID to the form
        layout=''
      >
       

        <Form.Item
          label="User Password"
          name="password"
          rules={[
            {
              required: true,
              message: 'Please input user password!',
            },
          ]}
        >
          <Input type='password'  placeholder="Please input user password"
                    allowClear/>
        </Form.Item>

        <Form.Item
          label="Confirm Password"
          name="confPassword"
          rules={[
            {
              required: true,
              message: 'Please input confirm password!',
            },
          ]}
        >
          <Input type='password'  placeholder="Please input confirm password"
                    allowClear/>
        </Form.Item>

        <Form.Item
          label="Email"
          name="email"
          rules={[
            {
              required: true,
              message: 'Please input email!',
            },
          ]}
        >
          <Input type='email'  placeholder="Please input user email"
                    allowClear/>
        </Form.Item>



      

      </Form>
    </Modal>
    </div>
  );
};

export default Sidebar;
